<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent && localService.languageContent.table">
  <div *ngIf="source !== undefined && source !== null">
    <div class="banner center" style="max-width:500px;padding:5px;">
      <div class="row freeze_height">
        <div class="col-2">
          &nbsp;
        </div>
        <div class="col-10" style="text-align:right;">
          <input autocomplete="off" type="text" style="width:calc(100% - 120px);" [(ngModel)]="wrapper.content.v1" placeholder="{{localService.languageContent.table.code}}" title="{{localService.languageContent.table.code}}" />
          <button type="button" class="btn btn-primary" (click)="onSave()">{{localService.languageContent.common.add}}</button>
        </div>
      </div>
      <div class="row row_header freeze_height">
        <div class="col-2">
          {{localService.languageContent.table.action}}
        </div>
        <div class="col-10">
          {{localService.languageContent.table.code}}
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row" *ngFor="let item of source.items">
          <div class="col-2">
            <i class="material-icons button icon_adjust" title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" : "toggle_off"}}</i>
          </div>
          <div class="col-10">
            <a class="button" [routerLink]="['/languages-contents' + localService.basicParamsString,item.key]"><span class="en">{{item.v1}}</span></a>
          </div>
        </div>
      </div>
    </div>
    <app-paging [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
  </div>
</div>
